import { render } from "./PropostaDocumentosPersonalizados.vue?vue&type=template&id=3208616b"
import script from "./PropostaDocumentosPersonalizados.vue?vue&type=script&lang=js"
export * from "./PropostaDocumentosPersonalizados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__